<template>
  <BaseNoticeItem
    :button-text="$t('Enter insurance information')"
    :button-url="buttonUrl"
    :status="$t('Information missing')"
    data-test="nl-insurance-recruiter-alert"
  >
    <template #head>
      <strong>{{ $t('Insurance information') }}</strong>
    </template>
    <template #body>
      {{
        $t(
          'Your insurance details are required to run compliance screening and meet requirements on new contracts when applicable.',
        )
      }}
    </template>
  </BaseNoticeItem>
</template>

<script setup>
import { computed } from 'vue'
import { useRedirectUri } from '@/composables/redirectUri'
import { useTranslation } from '@/composables/translation'
import { laravelNamedRoute } from '@/utils/laravelNamedRoutes'
import namedRoutes from '@/utils/laravelNamedRoutes.json'
import BaseNoticeItem from '@/components/BaseNoticeItem.vue'

const { $t } = useTranslation()
const { redirectUri } = useRedirectUri()

const buttonUrl = computed(() => {
  const path = laravelNamedRoute(
    namedRoutes.frontend.user.profile.edit,
    { redirect_uri: redirectUri },
    false,
  )
  return `${path}#insurance-information`
})
</script>
